module.exports = "/images/no-image.png?759be9ecf4f7857286c30fd832f76d6d";